import React, { useState } from 'react';
import styled from 'styled-components';

import { AutoCompleteProps } from 'antd/lib/auto-complete';
import { TagProps } from 'antd/lib/tag';
import AutoComplete from '../AutoComplete';
import Icon from '../Icon';
import theme from '../theme';
import { BaseTag } from './common';

interface AddTagProps extends TagProps {
  onSelectOption: (value: any) => void;
  options: any[];
  autoCompleteProps?: AutoCompleteProps;
}

const AddTag: React.FC<AddTagProps> = props => {
  const { autoCompleteProps, onSelectOption, options, ...tagProps } = props;

  const [active, setActive] = useState(false);

  const _onSelect: AutoCompleteProps['onSelect'] = (value: any) => {
    setActive(false);
    onSelectOption(value);
  };

  return active ? (
    <StyledAutoComplete
      autoFocus
      open={active}
      options={options}
      onSelect={_onSelect}
      onBlur={() => setActive(false)}
      size="small"
      getPopupContainer={trigger => trigger.parentNode}
      filterOption={(input, option) =>
        option.value.toUpperCase().includes(input.toUpperCase())
      }
      dropdownStyle={{ zIndex: 2001, minWidth: 125 }} // one higher than hard-coded mobile drawer
      {...autoCompleteProps}
    />
  ) : (
    <StyledTag
      icon={<Icon type="plus" height={13} width={13} offset={[0, 1.25]} />}
      color={theme.gray8}
      onClick={() => setActive(true)}
      {...tagProps}
      data-cy="add-tag"
    >
      Add
    </StyledTag>
  );
};

const StyledAutoComplete = styled(AutoComplete)`
  width: 70%;
`;

const StyledTag = styled(BaseTag)`
  cursor: pointer;
  background-color: ${theme.white};
  border: 1px dashed ${theme.gray5};
`;

export default AddTag;
